






































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  SetupContext
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import MemberKey from "@/components/member-key";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const displayuiStore = inject(DisplayUIKey);
    if (!displayuiStore) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }

    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }

    const globalStore = context.root.$store;
    const accessToken = computed(() => globalStore.auth.token);

    const response = computed(() => memberStore.response);
    const isShowPin = ref<boolean>(false);
    let displayFlag = ref(false);
    const pinUpdateParams = computed(() => memberStore.pinUpdateParams);
    const displayPinUpdateErrorFlag = computed(
      () => memberStore.displayPinUpdateErrorFlag
    );
    const s3ImageSrcList = computed(() => memberStore.s3ImageSrcList);

    const loading = computed(() => memberStore.loading);

    const send = async () => {
      displayuiStore.openOverlayLoading();
      memberStore.setAuthorizationHeader(accessToken.value);
      await memberStore.postMemberPinUpdate();
      displayuiStore.closeOverlayLoading();
      if (response.value.status != 201) {
        // メッセージがあれば表示
        if (
          response.value.data.messages &&
          response.value.data.messages.length > 0
        ) {
          displayuiStore.showErrorSnackBar(response.value.data.messages[0]);
          return;
        }
        displayuiStore.showErrorSnackBar("送信に失敗しました。");
        return;
      }
      memberStore.clearResponse();
      context.root.$router.push({ name: "MemberPersonalUpdatePinComplete" });
    };

    onMounted(() => {
      memberStore.clearResponse();
      memberStore.setAuthorizationHeader(accessToken.value);
      memberStore.validatePinUpdateParams();
      if (displayPinUpdateErrorFlag.value) {
        context.root.$router.push({ name: "MemberPersonalUpdatePin" });
      } else {
        displayFlag.value = true;
      }
    });

    return {
      displayFlag,
      loading,
      response,
      isShowPin,
      pinUpdateParams,
      s3ImageSrcList,
      send
    };
  },
  components: {}
});
